import { Box, Button, Typography } from '@mui/material';
import { FormProvider, useForm } from 'react-hook-form';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { InputKit } from '../../../components/UI';
import { AuthService } from '../../../Service/AuthService';
import { useAppDispatch } from '../../../store/hooks';
import { createNotification } from '../../../store/notifications/notification-slice';
import { zodResolver } from '@hookform/resolvers/zod';
import { schema } from './validations';
import { useEffect } from 'react';

export interface IFormInput {
  name: string;
  lastName: string;
  password: string;
  confirmPassword: string;
  email: string;
  phone: string;
  terms: boolean;
}

const Register = () => {
  const appDispatch = useAppDispatch();
  const navigate = useNavigate();
  const { info, answers } = useLocation().state || {};

  const methods = useForm<any>({
    resolver: zodResolver(schema),
    defaultValues: { email: info?.email },
  });
  const { handleSubmit, setError } = methods;

  useEffect(() => {
    if (!info) {
      navigate('/');
    }
  }, []);

  const registerUser = async (values: IFormInput) => {
    try {
      await AuthService.register({ ...info, ...values, answers });

      appDispatch(
        createNotification({
          type: 'success',
          message:
            'User created successfully! Please Check Your Email To Verify Your Account',
        })
      );

      navigate('success');
    } catch (error: any) {
      if (error.message === 'User do not exist in Redtail!') {
        setError('email', {
          type: 'required',
          message:
            'Email does not exist in Redtail! Please contact your account manager.',
        });
      } else if (error.message === 'User already exist!') {
        setError('email', {
          type: 'required',
          message: 'User already exists ! Please login.',
        });
      }
    }
  };

  if (!info) return null;

  return (
    <FormProvider {...methods}>
      <Box
        sx={{
          display: 'flex',
          width: '100%',
          height: '100vh',
          justifyContent: 'center',
          alignItems: 'center',
          '@media (max-width: 768px)': {
            alignItems: 'unset',
          },
        }}
      >
        <form
          style={{
            maxWidth: '500px',
            width: '100%',
            display: 'flex',
            flexDirection: 'column',
            gap: '48px',
          }}
          onSubmit={handleSubmit(registerUser)}
        >
          <Typography variant='h1'>
            {info.name}, let's create an account
          </Typography>

          <Box
            sx={{
              display: 'flex',
              flexDirection: 'column',
              gap: '16px',
            }}
          >
            <InputKit name='email' placeholder='Email' type='email' disabled />
            <InputKit name='password' type='password' placeholder='Password' />
            <InputKit
              name='confirmPassword'
              type='password'
              placeholder='Confirm password'
            />
          </Box>

          <Button
            sx={{
              background: '#3293DB',
              color: '#fff',
              width: '100%',
              boxShadow: 'unset',
              fontSize: '14px',
              lineHeight: '17px',
            }}
            type='submit'
            variant='contained'
          >
            Continue
          </Button>
          <Typography
            fontSize={'16px'}
            textAlign={'center'}
            variant='body1'
            color={'#655C68'}
            fontWeight={400}
          >
            Do you have an account?{' '}
            <Link
              style={{
                color: '#3293DB',
                fontWeight: 500,
                textDecoration: 'none',
              }}
              to={'/'}
            >
              Log in
            </Link>
          </Typography>
        </form>
      </Box>
    </FormProvider>
  );
};

export default Register;
